import {
  PutExpenseItemReqObj,
  PutExpenseItemResObj
} from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

/** 費目要否更新 */
export class ExpenseItemGateway {
  static putExpenseItem = async (params: PutExpenseItemReqObj) => {
    return await yamadumiApi.put<PutExpenseItemResObj>('/api/building/expense', params)
  }
}
